import { render, staticRenderFns } from "./fottom.vue?vue&type=template&id=6b3906dc"
import script from "./fottom.vue?vue&type=script&lang=js"
export * from "./fottom.vue?vue&type=script&lang=js"
import style0 from "./fottom.vue?vue&type=style&index=0&id=6b3906dc&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_81040fa6e1252f4179d1cbcf51812dc9/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports